// extracted by mini-css-extract-plugin
export default {"itemWrapper":"UserInfoLocationItem_itemWrapper__tVLja","iconWrapper":"UserInfoLocationItem_iconWrapper__10bLz","location":"UserInfoLocationItem_location__udZNx"};